import React from 'react';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import Footer from '../components/resuableComponents/Footer';
import { Container, Divider, Grid } from '@mui/material';
import { useEffect } from 'react';

const step = [
	'No minimum wallet',
	'Same day delivery',
	'Pre Integrated GDS & APIs.',
	'Multiple Supplier Inventory',
	'Offline Flight Inventory Management',
	'Real time booking',
	'Real time cancellation',
	'Real time availability',
	'Live Fare rules',
	'Responsive design',
	'All device support',
	'Custom B2C Home Page',
	'Logo Design',
];

const step2 = [
	'Page Management',
	'Blog management',
	'Website Management',
	'SEO Friendly',
	'Visitor Tracking',
	'Live Chat Integration',
	'Own Branding',
	'Payment Gateway Integration',
	'Email Integration',
	'SMS Integration',
	'Social Media Integration',
	'Customer dashboard',
	'Centralised Mid office',
];
const step3 = [
	'Markup management',
	'Offer Management',
	'Discount Management',
	'Convenience Fee Management',
	'Coupon Management',
	'Staff Management',
	'Advance reports',
	'Unlimited Bandwidth',
	'SSL Secure website',
	'Customer Feedback',
	'E Ticket',
	'large service network',
	'24*7 technical support',
];
const B2B2BWL = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	return (
		<div>
			<Navbar />
			<div
				style={{
					backgroundImage:
						"url('https://aryaaviation.com/assets/images/b2b2b-white-label-head.jpg')",
					height: '25vh',
					fontSize: '50px',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
				}}>
				<h1 style={{ textAlign: 'center', color: 'white', padding: 10 }}>
					B2B2B WHITE LABEL
				</h1>
				<h6 style={{ textAlign: 'center', fontSize: 20, color: 'white' }}>
					B2B2B WHITE LABEL
				</h6>
			</div>
			<div style={{ padding: 10 }}>
				<h1 style={{ textAlign: 'center', fontSize: 30 }}>
					B2B2B WHITE LABEL Travel Website
				</h1>
				<Divider />
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={4}>
							<img src='https://aryaaviation.com/assets/images/b2bb.jpg' />
						</Grid>
						<Grid item xs={8}>
							<p>
								B2B2B White Label System is suitable for the People who want to
								start TRAVEL BUSINESS with a big network in which agents as well
								as ditributors can be add. Now it is possible to get your
								readymade travel portal within a day at a affordable price. Arya
								Aviation TECHNOLOGIES provides BEST WHITE LABEL BOOKING SYSTEM
								at a affordable price.
							</p>
							<br />
							<p>
								The business model of Online Travel Agency is different from
								retail business. Online travel agency never keeps inventories in
								hand, rather options are searched based on client's request and
								booking is done at client confirmation. In B2C - Business to
								Customer model, clients can search and book the tickets and
								packages on the online travel portal. But in B2B2B -Business to
								business to business model, admin can give TRAVEL PORTAL to
								distributors and agents to book tickets and packages.
							</p>
							<br />
							<p>
								B2B2B Travel Portal Solution connect Distributors and travel
								agents. In B2B2B booking system, distributors can also add
								agents and set discounts and markups.
							</p>
						</Grid>
					</Grid>
				</Container>
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={12}>
							<p>
								As our team have 10+ years great experience in travel technology
								so we develop B2B2B portal with all updated features. Arya
								Aviation provides technically strong and reliable B2B2B Travel
								Portal Solution so you and your sub Agent with can grow your
								business.
							</p>
							<br />
							<p>
								To avoid system or office dependency we develop fully responsive
								and device friendly user interface. Any B2B2B user can login
								from mobile and make bookings without interruption. Arya
								Aviation provides unlimited bandwidth so n number of user can
								access system and use services quickly. .
							</p>
							<br />
							<p>
								On B2B2B Travel Portals registered Distributors and sub agents
								both can use the services. Our B2B2B Travel Portal provides
								complete control of creating agents and their logins, top-up and
								deduction of credit limit/balance, activating or deactivating
								agents, monitoring bookings/commissions/sales, modifying
								mark-ups/discounts to Distributor. B2B2B Travels Portals has all
								the travel services like Flight Booking, Hotel Booking, Bus
								Booking and Car Booking.
							</p>
							<br />
							<p>
								In B2B2B Portal, you can create Distributors for your Agency.
								Distributors can also create Agents for his/her Agency. Here you
								can use your network to grow your business.
							</p>
						</Grid>
					</Grid>
				</Container>
			</div>
			<div style={{ background: '#0a74c0', padding: 13 }}>
				<Container>
					<p style={{ color: 'white', fontSize: 14 }}>
						The fastest way to grow your business with the leader in Travel
						Technology Check out our options and features included.
					</p>
				</Container>
			</div>
			<Container style={{ background: '#eaeaea', marginTop: 20, padding: 20 }}>
				<p style={{ fontSize: 14, fontWeight: 'bold' }}>
					Features of B2C Travel Portal:-
				</p>
			</Container>
			<Container style={{ marginTop: 10 }}>
				<Grid container>
					<Grid item xs={4}>
						{step.map((d) => {
							return <p style={{ marginTop: 5 }}>{d}</p>;
						})}
					</Grid>
					<Grid item xs={4}>
						{step2.map((d) => {
							return <p style={{ marginTop: 5 }}>{d}</p>;
						})}
					</Grid>
					<Grid item xs={4}>
						{step3.map((d) => {
							return <p style={{ marginTop: 5 }}>{d}</p>;
						})}
					</Grid>
				</Grid>
			</Container>
			<Footer />
		</div>
	);
};

export default B2B2BWL;
